// ========================
// Global Loading Modal Utility
// ========================
import * as bootstrap from "bootstrap";

window.showLoadingModal = function(message = 'Processing...') {
  let modal = document.getElementById('globalLoadingModal');
  
  // Create modal if it doesn't exist
  if (!modal) {
    const modalHTML = `
      <div class="modal fade" id="globalLoadingModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center py-5">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <h5 class="mt-3" id="loadingModalMessage">Processing...</h5>
              <p class="text-muted" id="loadingModalSubtext">Please wait...</p>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    modal = document.getElementById('globalLoadingModal');
  }
  
  // Update message
  const messageEl = document.getElementById('loadingModalMessage');
  if (messageEl) messageEl.textContent = message;
  
  // Show modal
  const bsModal = new bootstrap.Modal(modal);
  bsModal.show();
  
  return bsModal;
};

window.hideLoadingModal = function() {
  const modal = document.getElementById('globalLoadingModal');
  if (modal) {
    const bsModal = bootstrap.Modal.getInstance(modal);
    if (bsModal) bsModal.hide();
  }
};

window.updateLoadingModal = function(message, subtext = 'Please wait...') {
  const messageEl = document.getElementById('loadingModalMessage');
  const subtextEl = document.getElementById('loadingModalSubtext');
  if (messageEl) messageEl.textContent = message;
  if (subtextEl) subtextEl.textContent = subtext;
};
